import {atom} from "jotai";
export const showNavigation=atom(false)